@if (canDisplay$ | async) {
  @if (!(busy$ | async)) {
    <button mat-icon-button [matMenuTriggerFor]="exportMenu">
      <app-icon icon="share"></app-icon>
    </button>
  }
  <mat-menu #exportMenu>
    @if (exportCsv$ | async) {
      <button mat-menu-item (click)="exportCsv()" i18n>Export as CSV</button>
    }
    @if (exportXlsx$ | async) {
      <button mat-menu-item (click)="exportXls()" i18n>Export to Excel</button>
    }
  </mat-menu>
  @if (showProgress$ | async) {
    <mat-progress-spinner i18n-matTooltip matTooltip="Exporting {{ progress$ | async }}%..." diameter="24" [value]="progress$ | async"></mat-progress-spinner>
  }
  @if (showPreparing$ | async) {
    <button mat-icon-button i18n-matTooltip matTooltip="Preparing to export...">
      <app-icon icon="share" beatFade="true"></app-icon>
    </button>
  }
}

